import * as React from 'react';
export const CZSvg = React.forwardRef(function CZSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#F6F9FC',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M1.51 1.128.8.596A.5.5 0 0 0 .656.52 2.01 2.01 0 0 0 0 2.009V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4h-1V2a1 1 0 0 0-1-1H2a.995.995 0 0 0-.49.128Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 6v4.002C0 11.106.895 12 1.994 12h12.012A1.998 1.998 0 0 0 16 10.002V6H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M.649 11.473A2.01 2.01 0 0 1 0 9.991V2.01C0 1.419.253.889.656.52A.5.5 0 0 1 .8.596l7.2 5.4-7.2 5.4a.5.5 0 0 1-.151.077Z',
      }),
    ),
  );
});
CZSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CZ = {
  category: 'flag',
  colorable: false,
  name: 'CZ',
  svg: CZSvg,
};
